import './intro.css';

function Intro({children}) {
    return (
        <div className='IntroBackground'>
            <div className="CenterBox">
                {children} 
            </div>
        </div>
    );
}

export default Intro;